import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { CLIENT_TYPE, IDENTITY_AGENT_TYPE, PROFIL, REQUEST_PASS_TYPE } from '../../../constants/enum';
import Radio from '@mui/material/Radio';
import {
  Accordion,
  AccordionDetails, AccordionSummary,
  Chip,
  Input,
  InputLabel,
  OutlinedInput,
  TextField,
  Typography,
} from '@mui/material';
import MySelect from '../../Layout/MySelect';
import MyButton from '../../Layout/MyButton';
import { faCheck, faWarning, faXmark } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MySearchSelect from '../../Layout/MySearchSelect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const StepIdentiteMandataireEtTransporteur = (props) => {
  const {
    refs,
    profil,
    complementIdentite,
    setComplementIdentite,
    handleChange,
    blacklisted,
    clients,
    demandePassageStyle,
    representative,
    setRepresentative,
    selectedRepresentative,
    handleChangeSelectClient,
    handleChangeSearchClient,
    handleChangeTextMask,
    PhoneMask,
    selectedTransporter,
    thirdParty,
    setThirdParty,
    demandePassage,
    validSteps,
    onNextStep,
    clientHasSap,
    notAbleToChange,
    reference,
    dataFetched
  } = props;
  const editable = validSteps.step2 && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.CLIENT) || notAbleToChange;
  const [open, setOpen] = useState(true);
  const [open1, setOpen1] = useState(true);
  const [open2, setOpen2] = useState(true);

  return (
    <div ref={(divRef) => refs.current['step-identite_mandataire'] = divRef} className='step'>
      <div className='step-content'>
        <div className='step-content-row'>
          <h3 className='modal-step-title'>Identification du mandataire / pétitionnaire / tiers payant</h3>
          <div className='row'
               style={{ flexWrap: 'nowrap', justifyContent: 'left', maxHeight: '125px', minHeight: '90px' }}>
            <FormControl style={{ margin: '20px' }}>
              <FormLabel>Le demandeur agit :</FormLabel>
              <RadioGroup row
                          name='value'
                          value={complementIdentite.value}
                          onChange={(e) => handleChange(e, complementIdentite, setComplementIdentite)}>
                <FormControlLabel value={IDENTITY_AGENT_TYPE.POUR_SON_COMPTE}
                                  control={<Radio />}
                                  style={{ height: 'auto' }}
                                  label='Pour son compte'
                                  disabled={editable} />
                <FormControlLabel value={IDENTITY_AGENT_TYPE.POUR_AUTRUI}
                                  control={<Radio />}
                                  style={{ height: 'auto' }}
                                  label="Pour le compte d'autrui"
                                  disabled={editable} />
              </RadioGroup>
            </FormControl>
            <FormControl style={{ margin: '20px' }}>
              <FormLabel>Militaire :</FormLabel>
              <RadioGroup row
                          name='military'
                          value={complementIdentite.military === 'true'}
                          onChange={(e) => handleChange(e, complementIdentite, setComplementIdentite)}>
                <FormControlLabel value={"true"}
                                  control={<Radio />}
                                  style={{ height: 'auto' }}
                                  label='Oui'
                                  disabled={editable} />
                <FormControlLabel value={"false"}
                                  control={<Radio />}
                                  style={{ height: 'auto' }}
                                  label='Non'
                                  disabled={editable} />
              </RadioGroup>
            </FormControl>
            {profil.profil === 4 || profil.profil === 3 || profil.profil === 2 || profil.profil === 1 && (
              <div style={{ margin: '20px' }}>
                <FormLabel>Statut du transporteur :</FormLabel><br />
                {blacklisted ? <Chip label='Blacklist' color='error' /> :
                  <Chip label='Aucune anomalie' color='success' />}
              </div>)}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ marginTop: '20px' }}><FormLabel style={{ fontSize: '25px', marginLeft: '30px', display: complementIdentite.value === IDENTITY_AGENT_TYPE.POUR_SON_COMPTE ? 'none' : 'block' }}>Le mandataire</FormLabel></div>
              <div style={{
                width: 'auto',
                flexGrow: 1,
                display: complementIdentite.value === IDENTITY_AGENT_TYPE.POUR_SON_COMPTE ? 'none' : 'block',
              }}>
                <Accordion
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                  onChange={() => setOpen1(!open1)}
                  expanded={open1}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon
                      style={{
                        border: '1px solid #CCCCCC',
                        borderRadius: '50%',
                      }}
                    />}
                    aria-controls='panel2a-content'
                    id='mandataire-header'
                    style={{
                      width: '98%',
                      borderBottom: '1px solid rgb(0 0 0 / 20%)',
                      marginTop: open1 ? '-64px' : '-40px'
                    }}
                  />
                  <AccordionDetails>
                    <div className='row' style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      paddingLeft: '30px',
                      height: 'fit-content',
                    }}>
                      {(profil.profil !== PROFIL.CLIENT && !(complementIdentite.value === IDENTITY_AGENT_TYPE.POUR_SON_COMPTE))  &&
                        <>
                          <FormLabel style={{ fontSize: '20px' }}>Choix du mandataire :</FormLabel>
                          <FormControl style={{ minWidth: 300 }}>
                            <MySelect name={'filterSelected'} label={'Choix du mandataire'}
                                      multiple={false}
                                      datas={clients}
                                      disableClass={true}
                                      displayLabel={true}
                                      disabled={editable}
                                      value={representative.user_id}
                                      handleChange={(e) => handleChangeSelectClient(e, {key: e.target.value}, false)}
                            />
                          </FormControl>
                        </>
                      }
                    </div>
                    <div className='row'
                         style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                      <TextField
                        label='N° TVA Intracommunautaire'
                        type='text'
                        name='numTva'
                        value={representative.numTva || ''}
                        style={demandePassageStyle.textField}
                        autoComplete='off'
                        onChange={(e) => handleChange(e, representative, setRepresentative)}
                        disabled={editable}
                        inputProps={{ maxLength: 14 }}
                      />
                      <TextField
                        label='N° SIRET / SIREN'
                        type='text'
                        name='numSiren'
                        value={representative.numSiren || ''}
                        style={demandePassageStyle.textField}
                        autoComplete='off'
                        disabled={editable}
                        onChange={(e) => handleChange(e, representative, setRepresentative, '^[0-9]*$')}
                        inputProps={{ maxLength: 14 }}
                      />
                    </div>
                    <div className='row'
                         style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                      <TextField
                        label='MANDATAIRE'
                        type='text'
                        name='transporteur'
                        value={representative.transporteur || ''}
                        style={{ ...demandePassageStyle.textField, width: '50%' }}
                        autoComplete='off'
                        onChange={(e) => handleChange(e, representative, setRepresentative)}
                        disabled={editable}
                      />
                      <div style={{ ...demandePassageStyle.textField, width: '50%' }}></div>
                    </div>
                    <div className='row'
                         style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                      <TextField
                        label='ADRESSE'
                        type='text'
                        name='adresse'
                        value={representative.adresse || ''}
                        style={demandePassageStyle.textField}
                        autoComplete='off'
                        onChange={(e) => handleChange(e, representative, setRepresentative)}
                        disabled={editable}
                      />
                      <TextField
                        label="COMPLÉMENT D'ADRESSE"
                        type='text'
                        name='complementAdresse'
                        value={representative.complementAdresse || ''}
                        style={demandePassageStyle.textField}
                        autoComplete='off'
                        onChange={(e) => handleChange(e, representative, setRepresentative)}
                        disabled={editable}
                      />
                    </div>
                    <div className='row'
                         style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                      <TextField
                        label='CODE POSTAL'
                        type='text'
                        name='codePostal'
                        value={representative.codePostal || ''}
                        style={demandePassageStyle.textField}
                        autoComplete='off'
                        onChange={(e) => handleChange(e, representative, setRepresentative, '^[a-zA-Z0-9]*$')}
                        inputProps={{ maxLength: 8 }}
                        disabled={editable}
                      />
                      <TextField
                        label='COMMUNE'
                        type='text'
                        name='commune'
                        value={representative.commune || ''}
                        style={demandePassageStyle.textField}
                        autoComplete='off'
                        onChange={(e) => handleChange(e, representative, setRepresentative)}
                        disabled={editable}
                      />
                      <TextField
                        label='PAYS'
                        type='text'
                        name='pays'
                        value={representative.pays || ''}
                        style={demandePassageStyle.textField}
                        autoComplete='off'
                        onChange={(e) => handleChange(e, representative, setRepresentative)}
                        disabled={editable}
                      />
                    </div>
                    <div className='row'
                         style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                      <TextField
                        label='EMAILS DE CONTACT'
                        type='text'
                        name='email'
                        value={representative.email || ''}
                        style={{ ...demandePassageStyle.textField, width: '100%' }}
                        autoComplete='off'
                        onChange={(e) => handleChange(e, representative, setRepresentative)}
                        disabled={editable}
                      />
                    </div>
                    <div className='row'
                         style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                        <TextField
                            label='N° TÉLÉPHONE 1'
                            value={representative.telephone1 || ''}
                            onChange={(e) => handleChangeTextMask(e, representative, setRepresentative)}
                            name='telephone1'
                            inputComponent={PhoneMask}
                            disabled={editable}
                            style={{ ...demandePassageStyle.textField, width: '50%' }}
                        />
                        <TextField
                            label='N° TÉLÉPHONE 2'
                            value={representative.telephone2 || ''}
                            onChange={(e) => handleChangeTextMask(e, representative, setRepresentative)}
                            name='telephone2'
                            inputComponent={PhoneMask}
                            disabled={editable}
                            style={{ ...demandePassageStyle.textField, width: '50%' }}
                        />
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            {/*endregion*/}
            {/*region Transporteur*/}
            <div style={{ marginTop: '20px' }}><FormLabel style={{ fontSize: '25px', marginLeft: '30px' }}>Le transporteur </FormLabel></div>
            <div style={{ width: 'auto', flexGrow: 1 }}>
              <Accordion
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
                onChange={() => setOpen2(!open2)}
                expanded={open2}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon
                    style={{
                      border: '1px solid #CCCCCC',
                      borderRadius: '50%',
                    }}
                  />}
                  aria-controls='panel2a-content'
                  id='mandataire-header'
                  style={{
                    width: '98%',
                    borderBottom: '1px solid rgb(0 0 0 / 20%)',
                    marginTop: open2 ? '-64px' : '-40px'
                  }}
                />
                <AccordionDetails>
                  <div className='row' style={{
                    display: (profil.profil === PROFIL.ADMINISTRATEUR && complementIdentite.value !== IDENTITY_AGENT_TYPE.POUR_AUTRUI) || (complementIdentite.value === IDENTITY_AGENT_TYPE.POUR_SON_COMPTE)  ? 'none' : 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    paddingLeft: '30px',
                    height: 'fit-content',
                  }}>
                    <FormLabel style={{ fontSize: '20px' }}>Choix du transporteur :</FormLabel>
                    <FormControl style={{ minWidth: 300, position: 'static' }}>
                      <MySearchSelect name={'filterSelected'}
                                      label={'TRANSPORTEUR / N° TVA / N° SIRET'}
                                      options={clients}
                                      disableClass={true}
                                      displayLabel={true}
                                      disabled={editable}
                                      value={complementIdentite.transporteur ?? ''}
                                      handleChange={(e, value) => handleChangeSelectClient(e, value)}

                      />
                    </FormControl>
                  </div>
                  <div className='row'
                       style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                    <TextField
                      label='N° TVA Intracommunautaire *'
                      type='text'
                      name='numTva'
                      value={complementIdentite.numTva || ''}
                      style={demandePassageStyle.textField}
                      autoComplete='off'
                      onChange={(e) => handleChange(e, complementIdentite, setComplementIdentite)}
                      disabled={editable}
                      inputProps={{ maxLength: 14 }}
                    />
                    <TextField
                      label='N° SIRET / SIREN'
                      type='text'
                      name='numSiren'
                      value={complementIdentite.numSiren || ''}
                      style={demandePassageStyle.textField}
                      autoComplete='off'
                      disabled={editable}
                      onChange={(e) => handleChange(e, complementIdentite, setComplementIdentite, '^[0-9]*$')}
                      inputProps={{ maxLength: 14 }}
                    />
                  </div>
                  <div className='row'
                       style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                    <TextField
                      label='TRANSPORTEUR *'
                      type='text'
                      name='transporteur'
                      value={complementIdentite.transporteur || ''}
                      style={{ ...demandePassageStyle.textField, width: '50%' }}
                      autoComplete='off'
                      onChange={(e) => handleChange(e, complementIdentite, setComplementIdentite)}
                      disabled={editable}
                    />
                    <div style={{ ...demandePassageStyle.textField, width: '50%' }}></div>
                  </div>
                  <div className='row'
                       style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                    <TextField
                      label='ADRESSE *'
                      type='text'
                      name='adresse'
                      value={complementIdentite.adresse || ''}
                      style={demandePassageStyle.textField}
                      autoComplete='off'
                      onChange={(e) => handleChange(e, complementIdentite, setComplementIdentite)}
                      disabled={editable}
                    />
                    <TextField
                      label="COMPLÉMENT D'ADRESSE"
                      type='text'
                      name='complementAdresse'
                      value={complementIdentite.complementAdresse || ''}
                      style={demandePassageStyle.textField}
                      autoComplete='off'
                      onChange={(e) => handleChange(e, complementIdentite, setComplementIdentite)}
                      disabled={editable}
                    />
                  </div>
                  <div className='row'
                       style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                    <TextField
                      label='CODE POSTAL *'
                      type='text'
                      name='codePostal'
                      value={complementIdentite.codePostal || ''}
                      style={demandePassageStyle.textField}
                      autoComplete='off'
                      onChange={(e) => handleChange(e, complementIdentite, setComplementIdentite, '^[a-zA-Z0-9]*$')}
                      inputProps={{ maxLength: 8 }}
                      disabled={editable}
                    />
                    <TextField
                      label='COMMUNE *'
                      type='text'
                      name='commune'
                      value={complementIdentite.commune || ''}
                      style={demandePassageStyle.textField}
                      autoComplete='off'
                      onChange={(e) => handleChange(e, complementIdentite, setComplementIdentite)}
                      disabled={editable}
                    />
                    <TextField
                      label='PAYS *'
                      type='text'
                      name='pays'
                      value={complementIdentite.pays || ''}
                      style={demandePassageStyle.textField}
                      autoComplete='off'
                      onChange={(e) => handleChange(e, complementIdentite, setComplementIdentite)}
                      disabled={editable}
                    />
                  </div>
                  <div className='row'
                       style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                    <TextField
                      label='EMAILS DE CONTACT *'
                      type='text'
                      name='email'
                      value={complementIdentite.email || ''}
                      style={{ ...demandePassageStyle.textField, width: '100%' }}
                      autoComplete='off'
                      onChange={(e) => handleChange(e, complementIdentite, setComplementIdentite)}
                      disabled={editable}
                    />
                  </div>
                  <div className='row'
                       style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                      <TextField
                          label='N° TÉLÉPHONE 1'
                          value={complementIdentite.telephone1 || ''}
                          onChange={(e) => handleChangeTextMask(e, complementIdentite, setComplementIdentite)}
                          name='telephone1'
                          inputComponent={PhoneMask}
                          disabled={editable}
                          style={{ ...demandePassageStyle.textField, width: '50%' }}
                      />
                      <TextField
                          label='N° TÉLÉPHONE 2'
                          value={complementIdentite.telephone2 || ''}
                          onChange={(e) => handleChangeTextMask(e, complementIdentite, setComplementIdentite)}
                          name='telephone2'
                          inputComponent={PhoneMask}
                          disabled={editable}
                          style={{ ...demandePassageStyle.textField, width: '50%' }}
                      />
                  </div>
                </AccordionDetails>
              </Accordion>
            </div>
            {/*endregion*/}
            {/*region Tiers payant*/}
            {(complementIdentite.military === null || complementIdentite.military === 'false') &&
              <>
                <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center', width: "-webkit-fill-available", paddingRight: '80px' }}>
                  <FormLabel style={{ fontSize: '25px', marginLeft: '30px', minWidth: '180px' }}>Le tiers facturé </FormLabel>
                  <div style={{ display: 'flex', marginLeft: 'auto' }}>
                    <FormControl style={{ margin: '20px' }}>
                      <RadioGroup row
                                  name='value'
                                  value={thirdParty.value}
                                  onChange={(e) => handleChange(e, thirdParty, setThirdParty)}
                                  defaultValue={CLIENT_TYPE.TIER}
                      >
                        {!(complementIdentite.value === IDENTITY_AGENT_TYPE.POUR_SON_COMPTE) &&
                          <FormControlLabel value={CLIENT_TYPE.MANDATAIRE}
                                            control={<Radio />}
                                            style={{ height: 'auto' }}
                                            label='Mandataire'
                                            disabled={editable} />
                        }
                        <FormControlLabel value={CLIENT_TYPE.TRANSPORTEUR}
                                          control={<Radio />}
                                          style={{ height: 'auto' }}
                                          label='Transporteur'
                                          disabled={editable} />
                        <FormControlLabel value={CLIENT_TYPE.TIER}
                                          control={<Radio />}
                                          style={{ height: 'auto' }}
                                          label='Tiers'
                                          disabled={editable} />
                      </RadioGroup>
                    </FormControl>
                  </div>
                  {profil.profil !== PROFIL.CLIENT &&
                    <div style={{display: clientHasSap ? "none" : 'flex', alignItems: "center", width: '70px', justifyContent: 'space-around'}}>
                      <div style={{fontWeight: 'bold'}}>
                        SAP
                      </div>
                      <FontAwesomeIcon icon={faWarning} style={{fontSize: "24px", color: 'red'}}/>
                    </div>
                  }
                </div>
                <div style={{
                  width: 'auto',
                  flexGrow: 1,
                }}>
                  <Accordion
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                    onChange={() => setOpen(!open)}
                    expanded={open}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon
                        style={{
                          border: '1px solid #CCCCCC',
                          borderRadius: '50%',
                        }}
                      />}
                      aria-controls='panel2a-content'
                      id='mandataire-header'
                      style={{
                        width: '98%',
                        borderBottom: '1px solid rgb(0 0 0 / 20%)',
                        marginTop: open ? '-70px' : '-65px'
                      }}
                    />

                    <AccordionDetails>
                      <div className='row'
                           style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                        <TextField
                          label={complementIdentite.military === 'true' ? 'N° TVA Intracommunautaire' : 'N° TVA Intracommunautaire *'}
                          type='text'
                          name='numTva'
                          value={thirdParty.numTva || ''}
                          style={demandePassageStyle.textField}
                          autoComplete='off'
                          onChange={(e) => handleChange(e, thirdParty, setThirdParty, '^[a-zA-Z0-9]*$')}
                          disabled={editable}
                        />

                        <TextField
                          label='N° SIRET / SIREN'
                          type='text'
                          name='numSiren'
                          value={thirdParty.numSiren || ''}
                          style={demandePassageStyle.textField}
                          autoComplete='off'
                          disabled={editable}
                          inputProps={{ maxLength: 14 }}
                          onChange={(e) => handleChange(e, thirdParty, setThirdParty, '^[0-9]*$')}
                        />
                      </div>
                      {profil.profil !== PROFIL.CLIENT &&
                      <div className='row'
                           style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                        <TextField
                          label='N° SAP'
                          type='text'
                          name='numSap'
                          value={thirdParty.numSap || ''}
                          style={demandePassageStyle.textField}
                          autoComplete='off'
                          onChange={(e) => handleChange(e, thirdParty, setThirdParty, '^[a-zA-Z0-9]*$')}
                          disabled={editable}
                          inputProps={{maxLength: 10}}
                        />
                        <TextField
                          label='N° SAP FILIALE'
                          type='text'
                          name='numSapSubsidiary'
                          value={thirdParty.numSapSubsidiary || ''}
                          style={demandePassageStyle.textField}
                          autoComplete='off'
                          disabled={editable}
                          onChange={(e) => handleChange(e, thirdParty, setThirdParty, '^[a-zA-Z0-9]*$')}
                          inputProps={{ maxLength: 10 }}
                        />
                      </div>
                      }
                      <div className='row'
                           style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                        <TextField
                          label='RAISON SOCIALE'
                          type='text'
                          name='transporteur'
                          value={thirdParty.transporteur || ''}
                          style={{ ...demandePassageStyle.textField, width: '50%' }}
                          autoComplete='off'
                          onChange={(e) => handleChange(e, thirdParty, setThirdParty)}
                          disabled={editable}
                        />
                        <div style={{ ...demandePassageStyle.textField, width: '50%' }}></div>
                      </div>

                      <div className='row'
                           style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                        <TextField
                          label='EMAILS DE CONTACT'
                          type='text'
                          name='email'
                          value={thirdParty.email || ''}
                          style={{ ...demandePassageStyle.textField, width: '100%' }}
                          autoComplete='off'
                          onChange={(e) => handleChange(e, thirdParty, setThirdParty)}
                          disabled={editable}
                        />
                      </div>
                      <div className='row'
                           style={{ flexWrap: 'nowrap', justifyContent: 'space-between', maxHeight: '100px' }}>
                          <TextField
                              label='N° TÉLÉPHONE 1'
                              value={thirdParty.telephone1 || ''}
                              onChange={(e) => handleChangeTextMask(e, thirdParty, setThirdParty)}
                              name='telephone1'
                              inputComponent={PhoneMask}
                              disabled={editable}
                              style={{ ...demandePassageStyle.textField, width: '50%' }}
                          />
                          <TextField
                              label='N° TÉLÉPHONE 2'
                              value={thirdParty.telephone2 || ''}
                              onChange={(e) => handleChangeTextMask(e, thirdParty, setThirdParty)}
                              name='telephone2'
                              inputComponent={PhoneMask}
                              disabled={editable}
                              style={{ ...demandePassageStyle.textField, width: '50%' }}
                          />
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </div>
              </>}
            {/*endregion*/}
          </div>
        </div>
        {
          (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) && demandePassage.id !== 0 &&
          <div className='row-without-height'
               style={{ justifyContent: 'flex-end', alignItems: 'center', height: '80px' }}>
            <MyButton
              style={validSteps['step2'] ? 'buttonRejected' : 'buttonValidation'}
              label={validSteps['step2'] ? `Rejeter l'étape` : `Valider l'étape`}
              icon={validSteps['step2'] ? faXmark : faCheck}
              onClick={() => {
                onNextStep(setComplementIdentite, complementIdentite, 2);
              }}
            />
          </div>
        }
      </div>
    </div>);
};

export default StepIdentiteMandataireEtTransporteur;
